export default "__VITE_ASSET__CxeiU533__"